import styled from 'styled-components';

import { CARD_HEIGHT } from '@/components/Card/Card.constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { ColTypes } from '@/constants/common';
import { commonSkeletonStyles, flexBetween, flexColumn } from '@/styles/common';
import { buildResponsiveGridMediaQueries } from '@/utils/helpers/getCSSGrid';

export const CardWrapper = styled.div<{ $isMine?: boolean }>`
  background-color: var(--bg-card);
  border-radius: 28px;
  padding: 20px;
  ${flexColumn};
  gap: 16px;
  color: var(--textAndLabels-main);
  border: 1px solid var(--border-secondary);
  height: ${({ $isMine }) =>
    $isMine ? CARD_HEIGHT.profile : CARD_HEIGHT.public};

  @media (max-width: ${BREAKPOINTS.mobile}) {
    height: ${({ $isMine }) =>
      $isMine ? CARD_HEIGHT.profileMobile : CARD_HEIGHT.public};
  }
`;

export const CardHeader = styled.div`
  ${flexBetween};
`;

export const CompanyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CardBody = styled.div`
  ${flexColumn};
  gap: 10px;
  flex: 1;
`;

export const CardActions = styled.div`
  ${flexColumn};
  gap: 14px;
  margin-top: auto;
`;

export const CardFooter = styled.div`
  ${flexBetween};
`;

export const SkeletonLine = styled.div<{ $width?: ColTypes; height?: number }>`
  ${({ $width }) =>
    buildResponsiveGridMediaQueries($width ?? { mobile: '100%' }, [
      'max-width'
    ])}
  width: 100%;
  height: ${({ height }) => `${height ? height : 10}px`};
  border-radius: 28px;
  ${commonSkeletonStyles}
`;

export const PromoteButtonSkeleton = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 28px;
  ${commonSkeletonStyles}
`;

export const SkeletonCircle = styled.div<{
  $size: ColTypes;
  $visible?: ColTypes;
}>`
  ${({ $visible }) =>
    $visible && buildResponsiveGridMediaQueries($visible, ['display'])}
  ${({ $size }) =>
    buildResponsiveGridMediaQueries($size ?? { mobile: '100%' }, [
      'width',
      'height'
    ])}
  border-radius: 110px;
  flex-shrink: 0;
  ${commonSkeletonStyles}
`;
